import React, { useState } from "react";
import withProviders from "../hooks/withProviders";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import { useFilterContext } from "../hooks/FilterContext";
import { ReviewManagementFiltersModal, ReviewManagementFiltersModalButton } from "../features/reviewmanagementfilters";
import { ClientServiceTermsManagementPageSubHeader, Main, ThemedIcon, ThemedParagraph } from "../components/utilities";
import PageHeader, { PageHeaderTop, PageHeaderBottom } from "../components/layout/PageHeader";
import { ManagementServiceTermsRouteTabs } from "../routes/management.serviceterms.routes";
import { FilterProvider, ServiceTermsManagementDefaultFilters } from "../hooks/FilterContext";
import { FormSelect } from "../components/forms";
import { Button } from "../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClientServiceTermsManagementFiltersModal, ClientServiceTermsManagementFiltersModalButton } from "../features/clientservicetermsfilters";

const ClientServiceTermsManagementHeaderTitle = styled.div`
    flex: 1;
    display: flex;
    font-size: 16px;

    & > span:not(:last-child) {
        margin-right: 1rem;
    }
`;

const ClientServiceTermsManagementFiltersAppliedWarningMessage = styled(ThemedParagraph)`
    font-size: 12px !important;
`;

export const ClientServiceTermsManagementFilterSubHeader = () => {

    const { clearFilter, filter : {}, defaultFilters, isFiltersApplied, setFilter, setShowFilterModal } = useFilterContext();

    return (
         <ClientServiceTermsManagementPageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {isFiltersApplied && (
                            <React.Fragment>
                                <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                <ClientServiceTermsManagementFiltersAppliedWarningMessage className="ms-2 text-muted">
                                    Warning - Filters are currently being applied to your results.
                                    <br />
                                    <a href="#" onClick={clearFilter}>Click here</a> to clear your filters.
                                </ClientServiceTermsManagementFiltersAppliedWarningMessage>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="d-flex justify-content-end gap-2 align-items-center">

                        <ClientServiceTermsManagementFiltersModalButton onClick={() => setShowFilterModal(true)} />
                    </div>
                </div>
            </ClientServiceTermsManagementPageSubHeader>
    )
}

export const ClientServiceTermsSetUpSubHeader = ({ onCreateClick }) => {

    return (
            <ClientServiceTermsManagementPageSubHeader>
                <div className="d-flex align-items-center flex-fill flex-row-reverse">
                    <Button variant="success" className={"me-4"} onClick={onCreateClick}> 
                        <FontAwesomeIcon className="me-1" icon={"fa-plus"} />
                        <span>Create SLA</span>
                    </Button>
                </div>
            </ClientServiceTermsManagementPageSubHeader>
    )
}

const ClientServiceTermsManagementLayout = () => {

    const { showFilterModal, setShowFilterModal } = useFilterContext();

    return <React.Fragment>
        <ClientServiceTermsManagementFiltersModal 
            handleClose={() => setShowFilterModal(false)}
            show={showFilterModal}
        />
        <PageHeader>
            <PageHeaderTop>
                <ClientServiceTermsManagementHeaderTitle>
                    <span>Service Terms Management</span>
                </ClientServiceTermsManagementHeaderTitle>
            </PageHeaderTop>
            <PageHeaderBottom>
                <ManagementServiceTermsRouteTabs />
            </PageHeaderBottom>
        </PageHeader>
        <Main className="d-flex flex-column">
            <Outlet />
        </Main>
    </React.Fragment>
}

export default withProviders([FilterProvider, { filterStore: "serviceterms", defaultFilters: ServiceTermsManagementDefaultFilters }])(ClientServiceTermsManagementLayout);